/* Section subhead — "Usage", "Plan & Billing" and the like. Page *titles* go
   through components/page-header.jsx; this shares its type so a subhead reads
   as the same family one step down. */

const DashboardHeader = ({ label, className = "", children }) => {
  return (
    <div className={className}>
      <h2 className="font-display text-ui-lg font-normal text-ink md:text-h6">{label}</h2>
      {children}
    </div>
  );
};

export default DashboardHeader;
